import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
// import { Facebook, Youtube, Linkedin } from 'lucide-react';
import { WhatsAppIcon } from './BrandIcons';
// import { SnapchatIcon, XIcon } from './BrandIcons';

const SOCIAL_LINKS_READY = true;

// Only links that reach a real ILoveConvert profile/chat are live.
// Facebook, YouTube, LinkedIn, X, and Snapchat are commented out — they
// pointed at the platforms' generic homepages, not an ILoveConvert page.
// Restore each one (and its import above) once a real profile exists.
const SOCIAL_LINKS = [
  // { name: 'Facebook',  href: 'https://www.facebook.com', icon: Facebook,      bg: '#1877F2' },
  { name: 'Instagram', href: 'https://www.instagram.com/iloveconvert_', icon: Instagram,     bg: 'linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)' },
  // { name: 'YouTube',   href: 'https://www.youtube.com', icon: Youtube,       bg: '#FF0000' },
  // { name: 'LinkedIn',  href: 'https://www.linkedin.com', icon: Linkedin,      bg: '#0A66C2' },
  // { name: 'X (Twitter)', href: 'https://www.x.com', icon: XIcon,       bg: '#000000' },
  { name: 'WhatsApp',  href: 'https://wa.me/919500869770', icon: WhatsAppIcon,  bg: '#25D366' },
  // { name: 'Snapchat',  href: 'https://www.snapchat.com', icon: SnapchatIcon,  bg: '#FFFC00', className: 'snapchat' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src="/favicon_io/android-chrome-192x192.png" alt="ILoveConvert" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <span style={{ fontFamily: 'Sora, sans-serif', fontWeight: 700, color: 'white', fontSize: '1.1rem' }}>
              ILoveConvert
            </span>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', lineHeight: 1.6 }}>
            Free online PDF and image tools. Merge, split, rotate and convert — fast, secure, no signup.
          </p>
          {SOCIAL_LINKS_READY && (
            <div className="social-icons">
              {SOCIAL_LINKS.map(s => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  title={s.name}
                  className={`social-icon${s.className ? ' ' + s.className : ''}`}
                  style={{ background: s.bg }}
                >
                  <s.icon size={17} />
                </a>
              ))}
            </div>
          )}
        </div>

        <div>
          <h4>PDF Tools</h4>
          {/* PDF to JPG and Compress PDF hidden while they don't work.
          <Link to="/convert/pdf-to-jpg">PDF to JPG</Link> */}
          <Link to="/convert/jpg-to-pdf">JPG to PDF</Link>
          <Link to="/merge-pdf">Merge PDF</Link>
          <Link to="/split-pdf">Split PDF</Link>
          {/* <Link to="/compress-pdf">Compress PDF</Link> */}
          <Link to="/rotate-pdf">Rotate PDF</Link>
        </div>

        <div>
          <h4>Image Tools</h4>
          <Link to="/image-convert?from=jpg&to=png">JPG to PNG</Link>
          <Link to="/image-convert?from=png&to=jpg">PNG to JPG</Link>
          <Link to="/image-convert?to=webp">Image to WebP</Link>
          <Link to="/image-convert?to=pdf">Image to PDF</Link>
          <Link to="/image-convert">All Image Formats</Link>
          <Link to="/remove-background">Remove Background</Link>
          <Link to="/image-to-text">Image to Text (OCR)</Link>
          <Link to="/articles/remove-background-from-image-ai-guide">Background Removal Guide</Link>
        </div>

        <div>
          <h4>Company</h4>
          <Link to="/articles">Articles</Link>
          <Link to="/about">About</Link> 
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/login">Login</Link>
          <Link to="/register">Sign Up Free</Link>
        </div>
      </div>

      {/* <div className="footer-bottom">
        <p>© {new Date().getFullYear()} ILoveConvert. All rights reserved. Powered by Techb Software Solutions Pvt Ltd</p>
      </div> */}
      <div className="footer-bottom">
  <p>© {new Date().getFullYear()} ILoveConvert. All rights reserved. Powered by Techb Software Solutions Pvt Ltd</p>
  
</div>
    </footer>
  );
}
